import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import type { HttpEvent } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '@/shared/services/authentication.service';
import { ConfigurationService } from '@/shared/services/configuration.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  paramIds = new Set();

  constructor(
    private authService: AuthenticationService,
    private configService: ConfigurationService,
    @Inject('LOCALSTORAGE') private localStorage: any
  ) {

  }

  private handleAuthError(errResponse: HttpErrorResponse): Observable<any> {

    let errorMessage = '';
    /* istanbul ignore if */
    if (errResponse.error instanceof ErrorEvent) { // client-side error

      errorMessage = `Error: ${errResponse.error.message}`;

      return throwError(errResponse);

    } else { // server-side error
      /* istanbul ignore if */
      if (errResponse.status === 401) {
        this.authService.logout();

      } else {

        if (errResponse.error.msg) {
          errorMessage = errResponse.error.msg;
        } else if (errResponse.error.suberror) {
          errorMessage = 'Missing consent to access resource';
        }

        return throwError(errResponse);

      }
    }
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let bearerToken = this.localStorage.getItem('bearer_token');
    const portalRaw = this.localStorage.getItem('portal');
    const appName = portalRaw ? JSON.parse(portalRaw) : '';
   

    if (!bearerToken || bearerToken === 'undefined' ||
      request.url.includes('sso/verifytoken')) {
      return next.handle(request);
    } else {
      const haystackPrefixes: string[] = [];
      const regions: string[] = Array.isArray(environment.config?.regionsList)
        ? environment.config.regionsList
        : [];
      regions.forEach((regionId) => {
        const url = environment.config?.[regionId]?.haystackUrl;
        if (url) haystackPrefixes.push(url);
      });

      if (haystackPrefixes.some((prefix) => request.url.startsWith(prefix))) {
        request = request.clone({
          setHeaders: {
            'content-type': 'text/zinc'
          }
        });
      }

      /* istanbul ignore else */
      if (bearerToken && bearerToken !== 'undefined') {

        const tokenReq = request.clone({
          setHeaders: {
            Authorization: `Bearer ${bearerToken}`,
            '75F-Application': (appName ? appName.toString().toUpperCase() : '')
          }
        });

        return next.handle(tokenReq)
          .pipe(
            catchError(err => this.handleAuthError(err))
          );
      } else {
        return next.handle(request);
      }
    }
  }
}

